import React, { useState, useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { CdsInputField, useFieldArray, useFormContext } from 'clayco-component-library';
import EmployeeLookup from '../../../Components/EmployeeLookup/EmployeeLookup';
import * as Icon from "react-bootstrap-icons";

//general question: does this modal really need to accomodate both edit and create?
//using one modal for each case muddies the code significantly, it seems it would be better to have two separate modals for each case
//this is probably the only place where that is necissary because it is the first edit that has a significant difference in functionality

const ManagementModalForm = ({
    data,
    setData,
    classSchema,
    editableUsers,
    setEditableUsers,
}) => {
    const { control, setValue, formState: { errors }, watch } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name: `canEdit` });

    const [newUsers, setNewUsers] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [author, setAuthor] = useState();

    useEffect(() => {
        console.log("data", data);
        setValue(`author`, data);
    }, []);

    useEffect(() => {
        const updateFields = async () => {
            if (fields.length > 0) {
                await remove();
            }

            if (data?.users) {
                
                const updatedUsers = Object.entries(data.users).map(([key, user]) => ({
                    employeeNumber: key,
                    ...user,
                }));
                setEditableUsers(updatedUsers);
            } else {
                await append({ additional: false });
            }
        };
        updateFields();
    }, []);

    const onCanEditSelected = (employee, index) => {
        if (employee?.employeeNumber === author?.[0]?.employeeNumber) {
            console.log("User should not add themselves");
            return;
        }
        setValue(`canEdit[${index}].employee`, employee);
    };

    function onEmployeeSelected(employee) {
        let tempObject = [{
            employeeName: employee?.displayName,
            employeeNumber: employee?.employeeNumber,
            employeeIdentifier: employee?.id
        }];
        setValue(`author`, tempObject);
        setAuthor(tempObject);
    }

    const deleteRow = (index) => {
        remove(index);
    };

    const deleteStaticUser = (index) => {
        const updatedUsers = [...editableUsers];
        updatedUsers.splice(index, 1);
        setEditableUsers(updatedUsers);
    };

    function addRow() {
        append({ employee: null });
    }

    useEffect(() => {
        console.log("errors", errors);
        if (!author || !author[0]?.employeeNumber) {
            setErrorMessage("author is required");
        } else {
            setErrorMessage("");
        }
    }, [author]);

    return (
        <>
            <Row>
                <Col hidden>
                    <div className="py-2">
                        <CdsInputField
                            initialValue={data.id}
                            name={`id`}
                            type="text"
                            key={`id`}
                            value={data.id}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="py-2" key={`div-author`}>
                        {data?.users ?
                            <CdsInputField
                                name="authorized"
                                type="text"
                                initialValue={data?.employeeName}
                                readOnly={true}
                                disabled={true}
                            />
                            :
                            <>
                                <EmployeeLookup
                                    defaultValue={data?.employeeName}
                                    onEmployeeSelected={onEmployeeSelected}
                                    label="Author"
                                    name={`author`}
                                    key={`author`}
                                    value={author}
                                    required={true}
                                    formSchema={classSchema}
                                />
                                <div className="invalid-feedback" style={{ display: "block", textAlign: "left" }}>
                                    {errors.author && errors.author?.employee?.message}
                                </div>
                                <span className="text-primary fst-italic">{errorMessage}</span>
                            </>
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <table className="table table-striped table-container">
                        <thead className="table-light">
                            <tr>
                                <td scope="col-sm-12">
                                    Can Edit On-Behalf-Of <span className="text-primary">*</span>
                                </td>
                                <td scope="col"></td>
                            </tr>
                        </thead>
                        <tbody>

                            {/* Static Users from data.users */}
                            {editableUsers.map((user, index) => (
                                <tr key={`static-${user.employeeNumber}`}>
                                    <td>
                                        <CdsInputField
                                            name={`user-${user.employeeNumber}`}
                                            type="text"
                                            initialValue={user.employeeName}
                                            readOnly={true}
                                            disabled={true}
                                        />
                                    </td>
                                    <td className="trash-icon">
                                        <Icon.TrashFill
                                            className="ms-3 icon text-primary"
                                            onClick={() => deleteStaticUser(index)}
                                            role="button"
                                        />
                                    </td>
                                </tr>
                            ))}

                            {/* Dynamic Rows from useFieldArray */}
                            {fields.map((field, index) => (
                                <tr key={field.id}>
                                    <td>
                                        <EmployeeLookup
                                            name={`canEdit[${index}].employee`}
                                            onEmployeeSelected={(employee) => onCanEditSelected(employee, index)}
                                            value={watch(`canEdit[${index}].employee`) || null}
                                            required={true}
                                            formSchema={classSchema}
                                        />
                                        <div className="invalid-feedback" style={{ display: "block", textAlign: "left" }}>
                                            {errors.canEdit && errors.canEdit[index]?.employee?.message}
                                        </div>
                                    </td>
                                    <td className="trash-icon">
                                        <Icon.TrashFill
                                            className="ms-3 icon text-primary"
                                            onClick={() => deleteRow(index)}
                                            role="button"
                                        />
                                    </td>
                                </tr>
                            ))}

                            <tr>
                                <td colSpan="3">
                                    <a className="text-primary" onClick={addRow}>Add Another Employee</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
    );
}

export default ManagementModalForm;